import { connect } from 'react-redux'
import component from './component'


const mapStateToProps = state => ({
    theme: state.configuration.modifiers.theme
})

export default connect(
    mapStateToProps,
    null
)(component)
